// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1WNM4","col":"styles_col__2BOBe"};